import { readPreviewTarget } from '../preview/previewTargetStorage'

export function getApiBaseUrl (): string {
  const override = readPreviewTarget()?.apiUrl
  if (override) {
    return override
  }
  return process.env.CORE_API_URL || 'http://localhost'
}

export default getApiBaseUrl
